import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {
    DialogActionsEnum,
    DialogComponent,
    DialogConfigInterface
} from 'appShared/components';
import {FormInterface, PermissionRuleInterface} from 'appShared/interfaces';
import {Subscription} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
    ApiError,
    ApiResponse, BrokerSearchOutputModel,
    HttpStatusCodesEnum,
    OrderRouteService,
    RouteSearchOutputInterface,
    ServerResponseData
} from '@spa/api';
import {Router} from '@angular/router';
import {AlertsService} from 'appShared/services';
import {
    AlertTypesEnum,
    PermissionRuleCheckStrategiesEnum,
    PermissionsEnum
} from 'appShared/enums';
import {FormComponent} from 'appShared/widgets';
import {PanelOrderRoutesMessages} from 'appAssets/messages';
import {
    OrderRoutesAssociationEnum,
    OrderRoutesFormErrorStatesEnum
} from 'appEntries/panel/enums';
import {BrokerAssociationForm} from 'appEntries/panel/forms';
import {EventsService} from 'appEntries/panel/services';

@Component({
    selector: 'app-associate-broker',
    templateUrl: './associate-broker.component.html',
    styleUrls: ['./associate-broker.component.scss']
})
export class AssociateBrokerComponent extends DialogComponent<AssociateBrokerComponent> implements FormInterface, OnDestroy, OnInit {

    protected subscriptions: Subscription[];
    public permissionRule: PermissionRuleInterface;
    public form: BrokerAssociationForm;
    public orderRouteAssociation: OrderRoutesAssociationEnum;
    public objectId: number;
    public availableBrokers: BrokerSearchOutputModel;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            orderRouteAssociation: OrderRoutesAssociationEnum,
            objectId: number,
            availableBrokers: BrokerSearchOutputModel,
            currencyCodes?: string[],
            selectedCurrencyCode?: string
        },
        protected router: Router,
        protected alertsService: AlertsService,
        protected orderRouteService: OrderRouteService,
        protected eventsService: EventsService,
        public dialogRef: MatDialogRef<AssociateBrokerComponent>,
    ) {
        super(dialogRef);
        this.subscriptions = [];
        this.permissionRule = {
            permissions: [PermissionsEnum.CrmTradingAccountsUpdateStatus],
            strategy: PermissionRuleCheckStrategiesEnum.Intersect
        };
        this.config = data.config;
        this.objectId = data.objectId;
        this.orderRouteAssociation = data.orderRouteAssociation;
        this.availableBrokers = data.availableBrokers;
    }

    handleErrorResponse(response: ApiResponse<ApiError[] | RouteSearchOutputInterface>, error: ApiError): string {
        if (Array.isArray(response.messages) && response.messages[0]) {
            return response.messages[0];
        }

        return this.getErrorMessageByApiError(error);
    }

    onFormSubmit(action?: number): void {
        if (action !== DialogActionsEnum.Confirm) {
            this.dialogRef.close(false);

            return;
        }

        if (this.validateForm()) {
            const requestSubscription = this.form.createRequest()
                .subscribe((response: ServerResponseData<null>) => {
                    if (response.status !== HttpStatusCodesEnum.Ok) {
                        (response.data as ApiError[]).map((error: ApiError) => this.handleErrorResponse(response, error))
                            .filter((errorMessage: string) => {
                                return errorMessage.trim();
                            }).forEach((errorMessage: string) => {
                            this.alertsService.addAlert(errorMessage);
                        });

                        return;
                    }

                    this.dialogRef.close(true);
                });
            this.subscriptions.push(requestSubscription);
        }
    }

    getFormMessages(controlLabel?: string): { [p: string]: string } {
        return FormComponent.getFormMessages(controlLabel);
    }

    validateForm(): boolean {
        return this.form.validateForm(this.getFormMessages);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription: Subscription) => subscription && subscription.unsubscribe());
    }

    ngOnInit(): void {
        this.initForm();
    }

    initForm(): void {
        this.form = new BrokerAssociationForm(
            this.orderRouteService,
            this.orderRouteAssociation,
            this.objectId,
            this.availableBrokers,
            this.data.currencyCodes,
            this.data.selectedCurrencyCode
        );
        this.form.initForm();
    }

    getSuccessFormMessage(): string {
        return PanelOrderRoutesMessages.RouteSetCreationSucceed.message;
    }

    getErrorMessageByApiError(error: ApiError): string {
        if (error.status === OrderRoutesFormErrorStatesEnum.CreateRouteSetFailed) {
            return PanelOrderRoutesMessages.RouteSetCreationFailed.message;
        }

        return PanelOrderRoutesMessages.UnknownError.message;
    }
}
